import cookie from '@s-ui/js/lib/cookie'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {DraftEntitiesFactory} from '../Entities/factory.js'
import {DraftErrorsFactory} from '../Errors/factory.js'
import {DraftResponsesFactory} from '../Responses/factory.js'
import {DraftValueObjectsFactory} from '../ValueObjects/factory.js'
import {CookieDraftRepository} from './CookieDraftRepository.js'
import {HTTPDraftRepository} from './HTTPDraftRepository.js'

export class DraftRepositoriesFactory {
  static hTTPDraftRepository = ({config}) =>
    new HTTPDraftRepository({
      config,
      draftEntityFactory: DraftEntitiesFactory.draftEntity,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      invalidDraftError: DraftErrorsFactory.invalidDraftError,
      notFoundDraftError: DraftErrorsFactory.notFoundDraftError,
      ongoingDraftResponseFactory: DraftResponsesFactory.ongoingDraftResponse,
      resultPublishDraftVOFactory: DraftValueObjectsFactory.resultPublishDraftValueObject,
      successResponseDraftVOFactory: DraftValueObjectsFactory.successResponseDraftValueObject,
      uploadResponseDraftVOFactory: DraftValueObjectsFactory.uploadResponseDraftValueObject
    })

  static cookieDraftRepository = ({config}) =>
    new CookieDraftRepository({
      config,
      cookie,
      draftEntityFactory: DraftEntitiesFactory.draftEntity,
      ongoingDraftResponseFactory: DraftResponsesFactory.ongoingDraftResponse,
      successResponseDraftVOFactory: DraftValueObjectsFactory.successResponseDraftValueObject
    })
}
